import { useState } from 'react';
import { Flame, X } from 'lucide-react';
import ArticleModal from './ArticleModal';
import InterstitialAd from './InterstitialAd';

const HotNewsFeed = ({ stories, isMobile = false }) => {
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [showInterstitial, setShowInterstitial] = useState(false);
  const [interstitialUrl, setInterstitialUrl] = useState('');

  const handleReadFullStory = (url) => {
    setInterstitialUrl(url);
    setSelectedArticle(null);
    setShowInterstitial(true);
  };

  const handleCloseInterstitial = () => {
    setShowInterstitial(false);
    setInterstitialUrl('');
  };

  return (
    <>
      <div className={`${isMobile ? '' : 'sticky top-32'}`} data-testid="hot-news-feed">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-orange-500 to-red-500 p-3 sm:p-4">
            <div className="flex items-center gap-2 text-white">
              <Flame className="w-5 h-5" />
              <h3 className="font-serif text-lg sm:text-xl font-bold">Hot News</h3>
            </div>
            <p className="text-white/90 text-xs mt-1">
              Emerging stories with limited coverage - catch them before they go mainstream
            </p>
          </div>

          {/* Hot Stories List */}
          <div className={`divide-y divide-gray-200 ${
            isMobile ? 'max-h-96' : 'max-h-[calc(100vh-300px)]'
          } overflow-y-auto`}>
            {stories.length === 0 ? (
              <div className="p-6 text-center text-gray-500">
                <p className="text-sm">No hot news at the moment</p>
              </div>
            ) : (
              stories.map((story) => {
                const article = story.articles[0];
                if (!article) return null;

                return (
                  <div
                    key={story.id}
                    className="p-3 sm:p-4 hover:bg-gray-50 cursor-pointer transition-colors"
                    onClick={() => setSelectedArticle(article)}
                    data-testid="hot-news-item"
                  >
                    <div className="flex gap-3">
                      {article.image_url && (
                        <img
                          src={article.image_url}
                          alt={article.title}
                          className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg flex-shrink-0"
                          onError={(e) => {
                            e.target.src = 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=200&q=80';
                          }}
                        />
                      )}
                      <div className="flex-1 min-w-0">
                        <h4 className="font-semibold text-sm line-clamp-2 text-gray-900 mb-1">
                          {article.title}
                        </h4>
                        <p className="text-xs text-gray-600">{article.source.name}</p>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>

      {/* Article Modal */}
      {selectedArticle && (
        <ArticleModal
          article={selectedArticle}
          isOpen={!!selectedArticle}
          onClose={() => setSelectedArticle(null)}
          onReadFullStory={handleReadFullStory}
        />
      )}

      {/* Interstitial Ad */}
      {showInterstitial && (
        <InterstitialAd
          targetUrl={interstitialUrl}
          onClose={handleCloseInterstitial}
          autoRedirectDelay={5}
        />
      )}
    </>
  );
};

export default HotNewsFeed;
